const Filters = {
  install(Vue) {
    Vue.filter('nl2br', (value) => {
      return String(value).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
    });

    Vue.filter('externalUrl', (url) => {
      if (!url) {
        return url;
      }

      if (url[0] === '/' || url[0] === '#') {
        return url;
      }

      if (!/^[\w+.-]+:\/\//m.test(url)) {
        return `http://${url}`;
      }

      return url;
    });
  },
};

export default Filters;
